import React from "react";
import FunctionalityTable from "../../../shared/FunctionalityTable/FunctionalityTable";

function FunctionalityOperator(props) {
  return <FunctionalityTable></FunctionalityTable>;
}

export default FunctionalityOperator;
